import {
  acbbeakerIcon,
  acbDiamondIcon,
  acbWheatIcon,
  fscbeakerIcon,
  fscDiamondIcon,
  fscWheatIcon,
  imfbeakerIcon,
  imfDiamondIcon,
  imfWheatIcon,
  immuneLeafIcon,
  nacbeakerIcon,
  nacDiamondIcon,
  nacWheatIcon,
  berbeakerIcon,
  berDiamondIcon,
  berWheatIcon,
  vbcbeakerIcon,
  vbcDiamondIcon,
  vbcWheatIcon,
  ryrbeakerIcon,
  ryrDiamondIcon,
  ryrWheatIcon,
  vepbeakerIcon,
  vepDiamondIcon,
  vepWheatIcon,
  vd3k2beakerIcon,
  vd3k2DiamondIcon,
  vd3k2WheatIcon,
  vd3k5beakerIcon,
  vd3k5DiamondIcon,
  vd3k5WheatIcon,
  tnkbeakerIcon,
  tnkDiamondIcon,
  tnkWheatIcon,
} from '../../src/images';

export const highlightsContent = {
  TNK: {
    icon: immuneLeafIcon,
    title: `How <span class='pricePerDay'>Think Factor</span> Stands Apart`,
    description:
      'Other products in the market focus on just one or two ingredients, offer lower potencies or non-standardized extracts, or only provide a 30-day supply at a higher price. By contrast, Think Factor offers:',
    highlights: [
      {
        icon: tnkbeakerIcon,
        title: 'High-Potency Citicoline (500 mg)',
        description:
          'For more significant memory and cognition improvement. Many formulas use lower doses.',
      },
      {
        icon: tnkDiamondIcon,
        title: 'Lutein and Zeaxanthin',
        description:
          'Two carotenoids from marigold known to support cognitive performance as well as overall vision health.',
      },
      {
        icon: tnkWheatIcon,
        title: 'Ingredient Synergy',
        description:
          'By pairing Citicoline (for brain cell membrane support and neurotransmitter function) with Lutein and Zeaxanthin (for memory support), Think Factor delivers a one-two punch for comprehensive brain performance.',
      },
    ],
  },
  ACB: {
    icon: immuneLeafIcon,
    title: `How <span class='pricePerDay'>We</span> Stand Apart`,
    description:
      'In the crowded world of antioxidant supplements, some products use lower-potency vitamins or skip important co-factors. Others can cost anywhere from $30–$40 per 30-day supply. By contrast, Antioxidants with Vitamin C and Bioflavonoids offers:',
    highlights: [
      {
        icon: acbbeakerIcon,
        title: 'Offers a Full 60-Day Supply',
        description:
          '120 capsules (60-day supply) at just $25.95, which comes out to $0.43 per day.',
      },
      {
        icon: acbDiamondIcon,
        title: 'Targets More Free Radicals',
        description:
          'Combines Multiple Bioflavonoids (Quercetin, Rutin, Citrus Bioflavonoids, Hesperidin) with targeted enzyme support (Superoxide Dismutase, Catalase).',
      },
      {
        icon: acbWheatIcon,
        title: 'Synergistic Ingredient Ratios',
        description: 'This goes far beyond standard “just vitamin C” formulas.',
      },
    ],
  },
  FSE: {
    icon: immuneLeafIcon,
    title: `How <span class='pricePerDay'>Full Spectrum E</span> Stands Apart`,
    description:
      'Most vitamin E products rely on lower-quality, synthetic forms of Vitamin E with Minimal or no added selenium or carotenoids and potencies that may not deliver meaningful benefits. Typical price ranges of high-potency vitamin E plus added nutrients can cost in excess of $60. In contrast, Full Spectrum E delivers:',
    highlights: [
      {
        icon: fscbeakerIcon,
        title: 'High Quality Ingredients',
        description:
          'Premium, branded ingredients known for purity and absorption. Each ingredient is carefully selected for proven potency and synergistic health benefits—giving you a smarter, more comprehensive nutritional advantage.',
      },
      {
        icon: fscDiamondIcon,
        title: 'Two Month Supply of Exceptional Value',
        description:
          'A 60-day supply (120 capsules) for $42.95—that’s around $0.72 per day for advanced nutritional support.',
      },
    ],
  },
  IMF: {
    icon: immuneLeafIcon,
    title: `How <span class='pricePerDay'>Immune Factors</span> Stands Apart`,
    description:
      'Other products in the market focus on just one or two ingredients, offer lower potencies or non-standardized extracts, or only provide a 30-day supply at a higher price. By contrast, Immune Factors offers:',
    highlights: [
      {
        icon: imfbeakerIcon,
        title: 'Five Carefully Selected Ingredients',
        description:
          'Our ingredients are selected for their clinically relevant potencies',
      },
      {
        icon: imfDiamondIcon,
        title: 'High Standardization',
        description:
          '(e.g., 4% echinacosides, 4% andrographolides, 97% berberine HCl) ensuring you get consistent, reliable results from every dose',
      },
      {
        icon: imfWheatIcon,
        title: 'Better Prices for Twice the Supply',
        description:
          '120 capsules (60 day supply at 2 capsules daily) for $89.95',
      },
    ],
  },
  NAC: {
    icon: immuneLeafIcon,
    title: `How <span class='pricePerDay'> NAC </span> Stands Apart`,
    description:
      'When looking at other NAC supplements, you’ll often find low potencies or missing synergistic minerals as well as Small bottle counts (e.g., 60 capsules) at a higher price point or artificial binders or fillers that can compromise purity. In contrast, with our NAC formula, you get:',
    highlights: [
      {
        icon: nacbeakerIcon,
        title: 'Better Value Per Serving',
        description:
          '120 Capsules—enough for a full 60-day supply (1 capsule, twice a day) for just $0.37 per day.',
      },
      {
        icon: nacDiamondIcon,
        title: 'Clean Ingredient List',
        description:
          'Just NAC, Selenium, Molybdenum, rice flour, and a plant-based capsule.',
      },
      {
        icon: nacWheatIcon,
        title: 'Synergistic Approach',
        description:
          'Supporting antioxidant defense, immune health, and detox in one convenient formula.',
      },
    ],
  },
  BER: {
    icon: immuneLeafIcon,
    title: `How <span class='pricePerDay'>We</span> Stand Apart`,
    description:
      'When comparing Berberine supplements, you’ll find a broad range of price points—from under $20 to over $50 for a month’s supply—and potencies that vary dramatically. Here’s what sets our Berberine apart:',
    highlights: [
      {
        icon: berbeakerIcon,
        title: 'High Potency, Clean Formula',
        description: `515 mg of Berberine HCI 97% Granular per capsule, derived from Berberis aristata (bark) extract and no unnecessary fillers for maximum purity.`,
      },
      {
        icon: berDiamondIcon,
        title: 'Better Value Per Serving',
        description:
          'At $32.95 for 60 capsules, you get a full month’s supply (taking 1 capsule twice daily). That’s about $1.10 per day—comparable to or better than many well-known brands with less potency.',
      },
      {
        icon: berWheatIcon,
        title: 'Strict Quality Standards',
        description:
          'We focus on purity and standardized ingredients, so you know exactly what you’re putting in your body.',
      },
    ],
  },
  VBC: {
    icon: immuneLeafIcon,
    title: `How <span class='pricePerDay'>Vitamin B Complex</span> Stands Apart`,
    description:
      'Many basic formulas on the market only include a few B vitamins—or they skimp on potency. Some brands can cost anywhere from $25–$40 for a 30-day supply. Here’s how Vitamin B Complex differs:',
    highlights: [
      {
        icon: vbcbeakerIcon,
        title: 'Complete & Potent Formula',
        description:
          'You get all the major B vitamins in meaningful amounts—plus Vitamin C, Inositol, Choline, and PABA—to maximize synergy and absorption. These all work in harmony to promote whole-body vitality.',
      },
      {
        icon: vbcDiamondIcon,
        title: 'High-Quality Ingredients',
        description:
          'We prioritize clean, effective ingredients without unnecessary fillers. Our capsules use Microcel® MC-102 microcrystalline cellulose and a simple gelatin capsule.',
      },
      {
        icon: vbcWheatIcon,
        title: 'Two Month Supply of Exceptional Value',
        description:
          'At just $22.95 for 120 capsules, you get up to a 60-day supply—making it about $0.38 per day, which is often less than half the daily cost of comparable high-potency formulas.',
      },
    ],
  },
  RYR: {
    icon: immuneLeafIcon,
    title: `How <span class='pricePerDay'>We</span> Stand Apart`,
    description: '',
    highlights: [
      {
        icon: ryrbeakerIcon,
        title: 'Supports Healthy Cholesterol',
        description:
          'Red Yeast Rice has been used for centuries in traditional health practices. Our formula includes Monacolin K, the key compound that helps keep cholesterol levels in check.',
      },
      {
        icon: ryrDiamondIcon,
        title: 'Promotes Heart Energy & Vitality',
        description:
          'CoQ10 is widely valued for its role in cellular energy. It helps protect your heart by promoting energy production where it matters most.',
      },
      {
        icon: ryrWheatIcon,
        title: 'Convenient & High-Value',
        description:
          'At just $46.95 for 120 capsules (a 60-day supply if taken as directed), you get robust support for about $0.78 per day.',
      },
    ],
  },
  VEP: {
    icon: immuneLeafIcon,
    title: `How <span class='pricePerDay'>Vessel Protection</span> Stand Apart`,
    description:
      "Many competitors use synthetic forms of folic acid or B12 or lower potency ingredients that don't have an impact on your cardiovascular health and energy. With our Vessel Protection you get:",
    highlights: [
      {
        icon: vepbeakerIcon,
        title: 'Cleaner Formulation',
        description:
          'Competitor supplements often include fillers or rely on cheaper, synthetic forms of B vitamins. Vessel Protection keeps it pure: no extra fluff, just high-quality active nutrients.',
      },
      {
        icon: vepDiamondIcon,
        title: 'Cost-Effective for Premium Quality',
        description:
          ' Many advanced B-vitamin products can be $1/day or more. Vessel Protection provides a full 60-day supply for $22.50—that’s about $0.38 per day for top-tier cardiovascular and energy support.',
      },
      {
        icon: vepWheatIcon,
        title: 'Targeted, Not Generic',
        description:
          'This is more than a standard B-complex. Vessel Protection zeroes in on heart health and essential energy, which resonates with doctors, integrative health practitioners, and proactive individuals alike.',
      },
    ],
  },
  DK2: {
    icon: immuneLeafIcon,
    title: `How <span class='pricePerDay'>We</span> Stand Apart`,
    description:
      'Our competitors will skimp on the K2 or only use vitamin D3, neglecting the essential role of K2. Offer smaller doses: Lower potency means you may have to take multiple capsules or buy more frequently. Charge premium prices: It’s common to see higher price tags for the same—or even lower—potencies.',
    highlights: [
      {
        icon: vd3k2beakerIcon,
        title: 'High-Potency, Synergistic Ingredients',
        description: `Vitamin D  is known to help your body absorb calcium effectively.
Vitamin K helps guide calcium to your bones (and away from where it doesn’t belong), supporting your heart and skeletal system.`,
      },
      {
        icon: vd3k2DiamondIcon,
        title: 'Optimal Daily Dose, No Wasted Capsules',
        description:
          'Each bottle contains 120 capsules, and you only need 1 capsule per day—that’s a full 4-month supply.',
      },
      {
        icon: vd3k2WheatIcon,
        title: 'Better Value & Savings',
        description:
          'At $12.95, our 120-count bottle provides a cost of about $0.11 per day—making daily wellness more affordable than ever.',
      },
    ],
  },
  DK5: {
    icon: immuneLeafIcon,
    title: `How <span class='pricePerDay'>We</span> Stand Apart`,
    description:
      'Our competitors will skimp on the K2 or only use vitamin D3, neglecting the essential role of K2. Offer smaller doses: Lower potency means you may have to take multiple capsules or buy more frequently. Charge premium prices: It’s common to see higher price tags for the same—or even lower—potencies.',
    highlights: [
      {
        icon: vd3k2beakerIcon,
        title: 'High-Potency, Synergistic Ingredients',
        description:
          'Vitamin D (as Cholecalciferol) – 50 mcg (2,000 IU): Known to help your body absorb calcium effectively.Vitamin K (as Menaquinone-7) – 200 mcg: Guides calcium to your bones (and away from where it doesn’t belong), supporting your heart and skeletal system.',
      },
      {
        icon: vd3k2DiamondIcon,
        title: 'Optimal Daily Dose, No Wasted Capsules',
        description:
          'Each bottle contains 120 capsules, and you only need 1 capsule per day—that’s a full 4-month supply.',
      },
      {
        icon: vd3k2WheatIcon,
        title: 'Better Value & Savings',
        description:
          'At $12.95, our 120-count bottle provides a cost of about $0.11 per day—making daily wellness more affordable than ever.',
      },
    ],
  },
};
